import type {SerializedCompStructure} from '@wix/document-services-types'

export const migrateStructuredMegaMenuSubmenuLayout = (dataItem: SerializedCompStructure['data']) => {
    dataItem.direction = dataItem.direction === 'inherit' ? 'ltr' : dataItem.direction
}
